import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getSeekBarBufferStyleObject } from './seekBarBuffer.style';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { css } from '../../../../common/styles/styles.utils';

export const SeekBarBuffer: FunctionComponent = () => {
  const currentVideoBufferedTime = useSelector(playerDataSelector.currentVideoBufferedTime);
  const currentVideoDuration = useSelector(playerDataSelector.currentVideoDuration);

  const styles = useStyles(getSeekBarBufferStyleObject, [currentVideoBufferedTime, currentVideoDuration]);
  const { seekBarBufferStyle } = styles;

  return (
    <div style={css(seekBarBufferStyle)} />
  );
};
